import { EventMapService } from "../services"

export const useEventMap = () =>{
      const registerEvent = async (data) => {
        await EventMapService.postEventMap(data)
      }
      
    return {registerEvent}
}